module.exports = __webpack_public_path__ + "static/media/contact.59843d0c.svg";